import React from "react";
export default function FireLossForm({ fireLosses, setFireLosses }) {
  const update = (idx, field, value) => {
    const arr = [...fireLosses];
    arr[idx][field] = value;
    setFireLosses(arr);
  };
  return (
    <fieldset className="fra-fieldset">
      <legend>Fire Loss Experience</legend>
      {fireLosses.map((loss, idx) => (
        <div key={idx} style={{ display: "flex", gap: 10, marginBottom: 6 }}>
          <input
            type="date"
            value={loss.date}
            onChange={e => update(idx, "date", e.target.value)}
            placeholder="Date"
          />
          <input
            type="text"
            value={loss.nature}
            onChange={e => update(idx, "nature", e.target.value)}
            placeholder="Nature"
          />
          <input
            type="text"
            value={loss.consequences}
            onChange={e => update(idx, "consequences", e.target.value)}
            placeholder="Consequences"
          />
          <button type="button" onClick={() => setFireLosses(fireLosses.filter((_, i) => i !== idx))}>✕</button>
        </div>
      ))}
      <button type="button" onClick={() => setFireLosses([...fireLosses, { date: "", nature: "", consequences: "" }])}>
        Add Fire Loss
      </button>
    </fieldset>
  );
}
